<template>
    <div v-if="show && loaded" class="nevs-popup-container">
        <div class="nevs-popup">
            <div class="popup-form">
                <NevsDateField v-model="data.date" :error="validation.date"
                               :label="$LANG.Get('fields.date')"></NevsDateField>
                <NevsSelect v-model="data.customer_id" :ajax="'select/customers'"
                            :error="validation.customer_id"
                            :label="$LANG.Get('fields.customer')"></NevsSelect>
                <NevsTextField v-model="data.name" :error="validation.name"
                               :label="$LANG.Get('fields.name')"></NevsTextField>
                <NevsTextArea v-model="data.note" :label="$LANG.Get('fields.note')"></NevsTextArea>
                <NevsSelect v-model="data.product_id" :nullable="true" :ajax="'select/products'"
                            :label="$LANG.Get('fields.product')"></NevsSelect>
                <NevsNumberField v-model="data.quantity" :decimal-places="3" :thousand-separator="''"
                                 :label="$LANG.Get('fields.quantity')"></NevsNumberField>
                <NevsCheckbox v-model="data.invoiced" :label="$LANG.Get('fields.invoiced')"></NevsCheckbox>
            </div>
            <div class="nevs-popup-buttons">
                <NevsButton class="error" @click="cancelClick()">
                    <i class="fa-solid fa-times"></i>
                    {{ $LANG.Get('buttons.cancel') }}
                </NevsButton>
                <NevsButton class="success" @click="saveClick()">
                    <i class="fa-solid fa-floppy-disk"></i>
                    {{ $LANG.Get('buttons.save') }}
                </NevsButton>&nbsp;
            </div>
        </div>
    </div>
</template>

<script>
import NevsButton from "@/components/nevs/NevsButton.vue";
import NevsSelect from "@/components/nevs/NevsSelect.vue";
import NevsTextField from "@/components/nevs/NevsTextField.vue";
import NevsTextArea from "@/components/nevs/NevsTextArea.vue";
import NevsDateField from "@/components/nevs/NevsDateField.vue";
import NevsNumberField from "@/components/nevs/NevsNumberField.vue";
import NevsCheckbox from "@/components/nevs/NevsCheckbox.vue";
import moment from "moment";

export default {
    name: "ModalActivity",
    components: {NevsCheckbox, NevsNumberField, NevsDateField, NevsTextArea, NevsTextField, NevsSelect, NevsButton},
    data() {
        return {
            data: {
                date: moment().format('YYYY-MM-DD'),
                customer_id: null,
                name: '',
                note: '',
                product_id: null,
                quantity: 1,
                invoiced: false
            },
            validation: {
                date: '',
                customer_id: '',
                name: ''
            },
            loaded: false
        }
    },
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        activityId: {
            type: Number,
            default: null,
        }
    },
    emits: ['done'],
    watch: {
        'show'() {
            this.loaded = false;
            this.data = {
                date: moment().format('YYYY-MM-DD'),
                customer_id: null,
                name: '',
                note: '',
                product_id: null,
                quantity: 1,
                invoiced: false
            };
            this.validation = {
                date: '',
                customer_id: '',
                name: ''
            };
            if (this.show && this.activityId != null) {
                let vm = this;
                this.$API.APICall('get', 'activities/' + this.activityId, {}, (data, success) => {
                    if (success) {
                        vm.data.date = data.activity.date;
                        vm.data.customer_id = data.activity.customer_id;
                        vm.data.name = data.activity.name;
                        vm.data.note = data.activity.note;
                        vm.data.product_id = data.activity.product_id;
                        vm.data.quantity = data.activity.quantity;
                        vm.data.invoiced = data.activity.invoiced;
                        vm.$nextTick(() => {
                            vm.loaded = true;
                        });
                    }
                });
            } else if (this.show) {
                this.$nextTick(() => {
                    this.loaded = true;
                });
            }
        }
    },
    methods: {
        cancelClick() {
            this.$emit('done', false);
        },
        saveClick() {
            let valid = true;

            if (this.data.customer_id == null) {
                valid = false;
                this.validation.customer_id = this.$LANG.Get('labels.customerIdMissing');
            } else {
                this.validation.customer_id = '';
            }

            if (this.data.name === '' || this.data.name === null) {
                valid = false;
                this.validation.name = this.$LANG.Get('labels.fieldMissing');
            } else {
                this.validation.name = '';
            }

            if (this.data.date == null) {
                valid = false;
                this.validation.date = this.$LANG.Get('labels.fieldMissing');
            } else {
                this.validation.date = '';
            }

            if (valid) {
                let vm = this;
                let action = 'post';
                let addition = '';
                if (this.activityId != null) {
                    action = 'put';
                    addition = '/' + this.activityId;
                }
                this.$API.APICall(action, 'activities' + addition, this.data, (data, success) => {
                    if (success) {
                        vm.$emit('done', true);
                    } else {
                        vm.$HELPERS.HandleServerError(vm, data);
                    }
                });
            }
        }
    }
}
</script>

<style scoped>
.popup-form {
    padding: 10px;
}

.nevs-popup {
    max-width: 500px;
}
</style>
